import {deserialize, deserializeAs} from 'libs/cerialize';

export class GridCountCellValueModel {
    @deserialize
    Value: string;

    @deserialize
    IsWrapped: boolean;

    @deserialize
    QueryColumnGuid: string;
}